import Box from '@/components/ui/box/box';
export default Box;
